import React from 'react'

export const StarCompImg = () => {
  return (
        <svg xmlns="http://www.w3.org/2000/svg" width="247" height="248" viewBox="0 0 247 248" fill="none">
            <path d="M1.09204 1.96008L245.548 246.416M245.548 1.96008L1.09204 246.416M1.09204 124.188H245.548M123.32 1.96008V246.416" stroke="black" strokeWidth="3" strokeLinejoin="round" />
        </svg>
  )
}
